import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {WeeklySummary} from "@shared/api/models/query/patient-statistics.model";
import {
    resolveWeeklyCarerCopy
} from "@cdss/pages/patient-overview-v2/detail/weekly/weekly-carer-copy";

/** Dashboard weekly panel (carer) never shows more than this many item labels per side
 *  before collapsing the rest into "+N more" (UNIVAPLAT-3041 AC "Three-item cap"). */
const MAX_VISIBLE_ITEMS = 3;

@Component({
    selector: 'cdss-patient-overview-v2-meal-plan',
    imports: [CommonModule],
    providers: [],
    standalone: true,
    templateUrl: './patient-overview-v2-meal-plan.component.html',
    styleUrl: './patient-overview-v2-meal-plan.component.scss'
})
export class PatientOverviewV2MealPlanComponent {
    loading = false;

    private _weeklySummary: WeeklySummary
    disabled: boolean = false

    /** ARFID signal for the card title (UNIVAPLAT-3041, `resolveWeeklyCarerCopy`) —
     *  "Meal plan" (standard) vs "This week's eating" (ARFID). */
    @Input() isArfid = false;

    @Input()
    set weeklySummary(weeklySummary: WeeklySummary) {
        this._weeklySummary = weeklySummary
        this.disabled = !weeklySummary || !weeklySummary.mealPlan || (weeklySummary.mealPlan?.wins.length === 0 && weeklySummary.mealPlan?.challenges.length === 0)
    }
    get weeklySummary(): WeeklySummary {
        return this._weeklySummary
    }

    get title(): string {
        return resolveWeeklyCarerCopy(this.isArfid).mealPlanTitle
    }

    // Item labels only (never notes/somethingElse — the live `mealPlan.challenges`/`.wins`
    // response is already a plain string[] per side, so there is nothing else to render),
    // capped at three with the remainder collapsed into "+N more" (UNIVAPLAT-3041).
    get visibleChallenges(): string[] {
        return (this.weeklySummary?.mealPlan?.challenges ?? []).slice(0, MAX_VISIBLE_ITEMS)
    }
    get moreChallengesCount(): number {
        return Math.max((this.weeklySummary?.mealPlan?.challenges?.length ?? 0) - MAX_VISIBLE_ITEMS, 0)
    }
    get visibleWins(): string[] {
        return (this.weeklySummary?.mealPlan?.wins ?? []).slice(0, MAX_VISIBLE_ITEMS)
    }
    get moreWinsCount(): number {
        return Math.max((this.weeklySummary?.mealPlan?.wins?.length ?? 0) - MAX_VISIBLE_ITEMS, 0)
    }
}
